module.exports = __webpack_public_path__ + "static/media/amo2.1d3d243a.webp";